module.exports = __webpack_public_path__ + "img/logo-sm.387fdef5.png";